import React from 'react'
import Navbar from '../layouts/Navbar'
import Footer from '../layouts/Footer'

const About = () => {
    return (
        <React.Fragment>
            <Navbar />
            <section id="home" class="section welcome-area bg-overlay d-flex align-items-center">
            </section>
            <section id="review" className="section review-area">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-10 col-lg-7">
                            <div className="section-heading text-center">
                                <h2 className="text-uppercase">AMAZING RIYADHOH</h2>
                                <p className="mt-4">
                                Menciptakan Aplikasi Muslim Yang Bisa Membantu Anda Dalam Mengevaluasi Ibadah Harian Anda. Selain Itu, Aplikasi Ini Dapat Meningkatkan Produktivitas dan Kapasitas Dalam Beribadah, Mendapatkan Insight Baru Dengan Konten-Konten Yang Islami dan Lain Sebagainya.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='section'>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-12 col-lg-12" style={{ verticalAlign: "bottom" }}>
                            <div className="section-heading text-center">
                                <img src="assets/img/coming-soon.svg" style={{ verticalAlign: "bottom" }} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default About